export default `
	query GetCart($id: ID) {
		getCart(id: $id) {
			id
			status
			subtotal
			discountAmount
			discountPercent
			discountConfiguration {
				id
				code
				applyTo
				amount
				percent
				referrer
				channel
				description
			}
			discountCodes
			total
			items {
				id
				type
				quantity
				price
				discountPrice
				discountAmount
				discountPercent
				discountedAmount
				meta {
					weight
					name
					gender
					interval
					products {
						id
						name
						description
						price
						image
						sku
						variants
						type
						category
						meta
					}
				}
			}
		}
	}
`
